import { render, staticRenderFns } from "./PdfControls.vue?vue&type=template&id=1d60cbb6&scoped=true&"
import script from "./PdfControls.vue?vue&type=script&lang=js&"
export * from "./PdfControls.vue?vue&type=script&lang=js&"
import style0 from "./PdfControls.vue?vue&type=style&index=0&id=1d60cbb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d60cbb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTextField,VTooltip})
